import { AppointmentDto } from "../../../../../Api/Model/AppointmentDto.csharp";
import { AppointmentBookingSystem } from "../../../../../Api/Model/AppointmentBookingSystem.csharp";

export const appointmentInitialState: AppointmentDto = {
  startTime: new Date(0),
  endTime: new Date(0),
  serviceId: "",
  specializationId: "",
  requireNotes: false,
  serviceVariantId: "",
  centerId: "",
  locationId: "",
  doctorId: "",
  notesLabel: "",
  appointmentBookingSystem: AppointmentBookingSystem.Dips,
  isRelatedAppointment: false,
};
